module.exports = __webpack_public_path__ + "static/media/icon-mail.404fc11b.svg";